import { CreatePageLayout } from 'framework/ui/layout';
import useLeaveService from 'domain/people/leave/shared/leaveService';
import LeaveForm from 'domain/people/leave/createupdate/LeaveForm';
import CreateLeaveBreadcrumbs from 'domain/people/leave/createupdate/Create/Breadcrumbs';
import useLeavesErrorMap from 'domain/people/leave/createupdate/errorHandlers';
import { useLeaveUrl } from 'domain/people/leave/leaveRouting';
import LeaveNotStrictRulesHandler from '../LeaveNotStictRulesHandler';
import { CreateForm } from 'framework/form';

const CreateLeave = () => {
  const { create, getValidationSchema } = useLeaveService();

  const errorsMap = useLeavesErrorMap();
  const { getListUrl } = useLeaveUrl();

  return (
    <CreateForm
      submitFormFunc={create}
      afterSubmit={{
        redirect: getListUrl(),
        message: 'You are awesome! The Leave has been successfully created.',
      }}
      getValidationSchemaFunc={getValidationSchema}
      errorsMap={errorsMap}
    >
      <LeaveNotStrictRulesHandler errorMap={errorsMap} />
      <CreatePageLayout title="Create: Leave" breadcrumbs={<CreateLeaveBreadcrumbs />}>
        <LeaveForm />
      </CreatePageLayout>
    </CreateForm>
  );
};

export default CreateLeave;
